module.exports = __webpack_public_path__ + "img/icon-installment2.2a32b52b.png";